import { Application } from "Application";
import { LayoutSprite } from "GameObjects/UI/LayoutSprite";
import { Expo, Linear, Sine, TimelineLite, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { LoadScreenLayout } from "Layouts/LoadScreenLayout";
import { LoadScreen } from "States/LoadScreen";
import * as Constants from "../Data/Constants";

export class SplashScreen extends LoadScreen implements ReturnType<typeof LoadScreenLayout> {

    public animateOut(pOnComplete: () => void): void {
        TweenLite.to([this.loaderSpinner, this.loaderBase], 0.25, {pixi: {y: this._size.y + this.loaderBase.height / 2}});
        super.animateOut(pOnComplete);
    }

    public onLoadComplete(pCallback: () => void): void {
        pCallback();
        // don't call super.onLoadComplete
    }
}
